import { RequiredIndicator } from '@wix/ambassador-forms-v4-form/types';
import { Text } from '@wix/wix-ui-tpa/cssVars';
import React, { useMemo } from 'react';
import { useConfig } from '../../contexts/config-context';
import { useFieldAttributes } from '../../services/field-attributes';
import { formatCurrency } from '../../utils/format-currency';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { Widget } from '../widget/widget';
import { classes } from './fixed-payment-field-wut.st.css';
export const FixedPaymentFieldWUT = ({ id, label, hideLabel = false, required = false, error, description, validation, FieldLayout, widgetHtml, widgetEnabled })=>{
    const { labelId, inputId, descriptionId } = useFieldAttributes(id, error, description);
    const { currency, regionalFormat } = useConfig();
    const paymentValidation = useMemo(()=>validation?.predefined?.paymentOptions?.products?.[0], [
        validation
    ]);
    const fixedPaymentValue = paymentValidation?.fixedPriceOptions?.price;
    const formattedValue = formatCurrency({
        amount: fixedPaymentValue,
        currency: currency?.code,
        locale: regionalFormat
    });
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: RequiredIndicator.NONE
            }),
        renderInput: ()=>widgetHtml && widgetEnabled ? /*#__PURE__*/ React.createElement(Widget, {
                fieldId: id,
                widgetHtml: widgetHtml,
                onChange: ()=>{},
                value: null
            }) : /*#__PURE__*/ React.createElement(Text, {
                className: classes.text,
                id: inputId,
                "data-hook": "fixed-payment-value",
                "aria-hidden": "false"
            }, formattedValue),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            })
    });
};

//# sourceMappingURL=fixed-payment-field-wut.js.map